import React from 'react';
import { SliderCheckBoxTemplate } from 'themes/components';
import PropTypes from 'prop-types';

class SliderCheckBox extends React.Component {
	render() {
		return <SliderCheckBoxTemplate {...this.props} />;
	}
}

SliderCheckBox.propTypes = {
	field: PropTypes.object,
	customMessage: PropTypes.string
}

export default SliderCheckBox;



// WEBPACK FOOTER //
// ./src/core/components/SliderCheckBox.jsx